import React, { Component } from 'react'

import { Container, Background, Title, Description } from './styles'

class ProductIntro extends Component {
  render() {
    return (
      <Container background={this.props.image}>
        <Background style={{ backgroundImage: `url(${this.props.image})` }} />
        <div>
          <Title>{this.props.title}</Title>
          <Description>{this.props.description}</Description>
        </div>
      </Container>
    )
  }
}

export default ProductIntro



// WEBPACK FOOTER //
// ./src/components/ProductIntro/index.js